export enum CalendarType {
  Google = 1,
  Microsoft = 2
} 